import { useEffect, useState } from 'react';
import { registrarServiceWorker } from '../lib/pwa';

/** Barra discreta quando existe versao nova publicada. */
export default function AvisoAtualizacao() {
  const [aplicar, setAplicar] = useState<(() => void) | null>(null);

  useEffect(() => {
    registrarServiceWorker((aplicarAgora) => setAplicar(() => aplicarAgora));
  }, []);

  if (!aplicar) return null;

  return (
    <div className="fixed inset-x-3 bottom-24 z-50 mx-auto flex max-w-md items-center justify-between gap-3 rounded-2xl bg-tinta-900 px-4 py-3 text-white shadow-barra md:bottom-4">
      <span className="text-sm">Tem uma versão nova do sistema.</span>
      <button
        onClick={() => aplicar()}
        className="rounded-xl bg-white px-3 py-1.5 text-sm font-semibold text-tinta-900"
      >
        Atualizar
      </button>
    </div>
  );
}
